<appTable v-if="shouldRenderConfig" :tableName="name" :isQuantityTable="true" v-bind:tableClass="getClassName">
    <slot></slot>    
</appTable>